var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFollowUpDeleteIcon = function SvgFollowUpDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#CF3131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 23C10.4906 23 10.1081 22.8259 9.78984 22.4778C9.47161 22.1296 9.3125 21.7111 9.3125 21.2222V9.66667H8.5V7.88889H12.5625V7H17.4375V7.88889H21.5V9.66667H20.6875V21.2222C20.6875 21.7111 20.5284 22.1296 20.2102 22.4778C19.8919 22.8259 19.5094 23 19.0625 23H10.9375ZM19.0625 9.66667H10.9375V21.2222H19.0625V9.66667ZM12.5625 19.4444H14.1875V11.4444H12.5625V19.4444ZM15.8125 19.4444H17.4375V11.4444H15.8125V19.4444Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFollowUpDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FollowUpDeleteIcon.e82939e4.svg";
export { ForwardRef as ReactComponent };